window.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('#primary-menu');
  if (menu) {
    const value = getComputedStyle(document.body).getPropertyValue(
      menu.dataset.background
    );
    const query = window.matchMedia('(max-width: 765px)');

    const gradient = {
      normal: `linear-gradient(to left,${value} 30%,transparent)`,
      mobile: `linear-gradient(to left,${value} 70%,transparent 30%)`,
    };

    if (window.innerWidth > 768) {
      menu.style.backgroundImage = gradient.normal;
    } else {
      menu.style.backgroundImage = gradient.mobile;
    }

    query.addEventListener('change', (e) => {
      if (e.matches) {
        menu.style.backgroundImage = gradient.mobile;
      } else {
        menu.style.backgroundImage = gradient.normal;
      }
    });
  }
});
